/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'gslb';
const componentName = 'gslb-ip-address-grid';
const prefix = `${moduleName}.${componentName}`;

export const siteControllerLabel = `${prefix}.siteControllerLabel`;

export const ENGLISH = {
    [siteControllerLabel]: 'Site Controller Cluster VIP Address ({0})',
};
